import { httpGet, httpPatch, httpPost } from "@/src/api/http";
import type { GetRes, PatchRes, PostRes, Req } from "@/src/api/types";

export function listEmsSpaces() {
    return httpGet<GetRes<"emsspaces/">>(`emsspaces/`);
}

export function listEmsPackages(emsSpaceId: string) {
    return httpGet<GetRes<"emsspaces/{ems_space_id}/packages/">>(`emsspaces/${emsSpaceId}/packages/`);
}

/** `push_all_check_ids` is a path segment the backend reads with `json.loads(segment.lower())`. */
const flag = (value: boolean) => (value ? "True" : "False");

export function getEmsSpaceUrl(emsSpaceId: string, graphId: number, pushAllCheckIds: boolean) {
    return httpGet<GetRes<"emsspaces/{ems_space_id}/graph/{graph_id}/url/{push_all_check_ids}/">>(
        `emsspaces/${emsSpaceId}/graph/${graphId}/url/${flag(pushAllCheckIds)}/`,
    );
}

export function pushPackageToEmsSpace(emsSpaceId: string, graphId: number, pushAllCheckIds: boolean) {
    return httpPost<PostRes<"emsspaces/{ems_space_id}/graph/{graph_id}/url/{push_all_check_ids}/">>(
        `emsspaces/${emsSpaceId}/graph/${graphId}/url/${flag(pushAllCheckIds)}/`,
        {},
    );
}

export function getEmsUrl() {
    return httpGet<GetRes<"emsurl/">>(`emsurl/`);
}

export function getCelonisApiStatus() {
    return httpGet<GetRes<"celonis_api/">>(`celonis_api/`);
}

/** Answers `false` rather than an error when the supplied credentials fail verification. */
export function updateCelonisApi(body: Req<"celonis_api/", "patch">) {
    return httpPatch<PatchRes<"celonis_api/">>(`celonis_api/`, body);
}

export function updateMcpApi(body: Req<"mcp_api/", "patch">) {
    return httpPatch<PatchRes<"mcp_api/">>(`mcp_api/`, body);
}
